import { BRAND } from "@/content/site";

export function buildWhatsappUrl(text) {
  const base = `https://wa.me/${BRAND.whatsappNumber}`;
  if (!text) return base;
  return `${base}?text=${encodeURIComponent(text)}`;
}
